import React, { FC } from 'react';

export const Tick: FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" {...props}>
    <path
      fill="currentColor"
      d="M21.681 7.623 10.062 19.24a1.535 1.535 0 0 1-2.173 0l-5.306-5.306a1.537 1.537 0 0 1 2.173-2.173l4.22 4.22L19.508 5.45a1.535 1.535 0 1 1 2.173 2.172Z"
    />
  </svg>
);
